import { render, staticRenderFns } from "./GestioneUtenti.vue?vue&type=template&id=94e88584&scoped=true&"
import script from "./GestioneUtenti.vue?vue&type=script&lang=js&"
export * from "./GestioneUtenti.vue?vue&type=script&lang=js&"
import style0 from "./GestioneUtenti.vue?vue&type=style&index=0&id=94e88584&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e88584",
  null
  
)

export default component.exports